import './MFlaunt.scss';
import { atom, useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { AchieveModel, HonorsInfoModel } from '@/models/typing';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Tracking } from '@/utils/tracking';
import BlankPage from '@/components/Error/blank';
import { fetchHonorsInfoState, honorsInfoState } from '@/models/honorsState';
import ErrorPage from '@/components/Error';
import { DefaultLoadingPage } from '@/components/Loading';
import { quizState } from '@/models/quizState';

const userSelectedAchieveState = atom<number>({
  key: 'userSelectedAchieveState',
  default: 0,
});

type flauntItemProps = {
  item: AchieveModel;
};

const FlauntItemComponent = ({ item }: flauntItemProps) => {
  const [userSelected, setUserSelected] = useRecoilState(
    userSelectedAchieveState
  );

  return (
    <div className='flaunt-item' onClick={() => {
      setUserSelected(item.achieve_id);
    }}
    >
      <img src={item.img} />
      <div className={userSelected === item.achieve_id ? 'board-s' : 'board-n'} ></div>
      <p>{item.title}</p>
    </div>
  );
};

export const FlauntPage = () => {
  const { logId } = useParams();

  const navigate = useNavigate();

  const info = useRecoilValue(honorsInfoState);

  const userSelectedAchieve = useRecoilValue(userSelectedAchieveState);

  const quiz = useRecoilValue(quizState);

  if (info.achieve_list.length === 0) {
    return <BlankPage />
  }

  const list = info.achieve_list.filter((item) => item.status == '1');

  return (
    <div className='mobile-flaunt'>
      <div className='title'></div>
      <div style={{ flex: 1, overflow: 'scroll' }}>
        {list.map((item, index) => (
          <FlauntItemComponent item={item} key={index} />
        ))}
        <div className='flaunt-control'>
          <div className='flaunt-back' onClick={() => {
            navigate(-1);
          }} ></div>
          <div className='flaunt-show' onClick={() => {
            Tracking.UP('click_all_answer_QuestionBank_share')
            navigate('/share/' + logId + '/' + `${userSelectedAchieve}` + '/' + `${quiz.questionnaire?.questionnaire_id ?? ''}`);
          }} >
          </div>
        </div>
      </div>
    </div>
  );
};


export const MobileFlaunt = () => {

  const { id } = useParams()

  const setHonorsInfo = useSetRecoilState(honorsInfoState);

  const { state, contents } = useRecoilValueLoadable<HonorsInfoModel>(fetchHonorsInfoState(id ?? ''));

  const refresh = useRecoilRefresher_UNSTABLE(fetchHonorsInfoState(id ?? ''));

  useEffect(() => {
    if (state === 'hasValue') {
      setHonorsInfo(contents);
    }
  }, [state]);


  switch (state) {
    case 'hasValue':
      return <FlauntPage />;
    case 'hasError':
      return <ErrorPage message={contents.message} onRetry={() => { refresh(); }} />;
    case 'loading':
      return <DefaultLoadingPage />;
  }
}


